import { babyface } from '../CDNUrl';

const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const HOME_BANNER_BLOG = {
  src: `${HOME_BANNER_URI}_blog.png`,
  alt: `블로그 읽고 배송비 무료 이벤트 홈배너`,
};
